import storeE from "../../../store";

export const validateStep2 = () => {
    const newState = storeE.getState();
    const val = newState.step2Validation;
    return newState.wizard.isStepValid && val.TitleValid.isValid && 
            ((newState.newSite.Template.config || {}).siteCustomName || val.NameValid.isValid) &&
            val.PurposeValid.isValid;
}


export const validate2 = () => {
    const newState = storeE.getState();
    const site = newState.newSite;
    return !!site.Title && !!site.Name && !!site.Purpose;
}



// WEBPACK FOOTER //
// ./src/components/CreateSite/Step2/Validator.js